export const LOAD_METHODS = 'LOAD_METHODS'